import { Injectable, inject } from '@angular/core';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import { ANALYTICS_EVENTS_LOGIN } from '../../data-access/login-modal/constants/analytics-constants';
import {
  STANDALONE_PAGE_URL,
  VIEW_NAME
} from '../../data-access/login-modal/constants/login-constant';
import { CreateMyPasswordFacade } from '../../data-access/login-modal/facade/create-my-password/create-my-password.facade';
import { ForgotLoginFacadeService } from '../../data-access/login-modal/facade/forgot-login-facade/forgot-login-facade.service';
import { RecoverYourAccountFacadeService } from '../../data-access/login-modal/facade/recover-your-account-facade/recover-your-account-facade.service';
import { ResetPasswordFacade } from '../../data-access/login-modal/facade/reset-password/reset-password.facade';
import { NextDisplayViewService } from '../../data-access/login-modal/services';

@Injectable({
  providedIn: 'root'
})
export class LoginStandaloneHelperService {
  url = '';
  queryParams: Record<string, string> = {};
  recoverYourAccountFacade = inject(RecoverYourAccountFacadeService);

  constructor(
    protected forgotLoginFacade: ForgotLoginFacadeService,
    protected nextDisplayView: NextDisplayViewService,
    protected createMyPasswordFacade: CreateMyPasswordFacade,
    protected resetPasswordFacade: ResetPasswordFacade,
    protected analytics: AnalyticsService
  ) {}

  routeToProfilePickerPageCheck() {
    return (
      this.url === VIEW_NAME.PROFILE_PICKER ||
      this.url === VIEW_NAME.PROFILE_PICKER_PAGE
    );
  }

  getRoutePathConfigCheck(currentRoute: string) {
    return (
      currentRoute !== VIEW_NAME.PROFILE_PICKER ||
      currentRoute !== VIEW_NAME.PROFILE_PICKER_PAGE
    );
  }

  isForgotLoginScreen() {
    return this.url === STANDALONE_PAGE_URL[VIEW_NAME.FORGOT_LOGIN_SCREEN];
  }

  isResetPasswordScreen() {
    return this.url === STANDALONE_PAGE_URL[VIEW_NAME.RESET_PASSWORD_SCREEN];
  }

  isUnlockYourAccountScreen() {
    return this.url === STANDALONE_PAGE_URL[VIEW_NAME.UNLOCK_ACCOUNT_SCREEN];
  }

  isLoginHelpScreen() {
    return this.url === STANDALONE_PAGE_URL[VIEW_NAME.LOGIN_HELP_SCREEN];
  }

  isAddEmailScreen() {
    return this.url === STANDALONE_PAGE_URL[VIEW_NAME.ADD_EMAIL_ADDRESS_SCREEN];
  }

  isAddSQAScreen() {
    return (
      this.url ===
      STANDALONE_PAGE_URL[VIEW_NAME.ADD_SECURITY_QUESTION_ANS_SCREEN]
    );
  }

  isAddAddressScreen() {
    return this.url === STANDALONE_PAGE_URL[VIEW_NAME.ADD_ADDRESS_SCREEN];
  }

  removeDisplayNone() {
    const loginModalDiv = document.querySelector('.login-modal') as HTMLElement;
    if (loginModalDiv) {
      loginModalDiv.classList.remove('d-none');
    }
  }

  isRefLinkPresent() {
    const urlParams = new URLSearchParams(window.location.search);
    const refLink = urlParams.get('refLink') ?? '';
    return !!refLink;
  }

  isQueryParamsForResetPasswordHelper() {
    if (this.isRefLinkPresent()) {
      this.recoverYourAccountFacade.initiateShowResetPassword();
    } else {
      this.resetPasswordFacade.resetForm();
      this.analytics.dispatchCustomEvent(
        ANALYTICS_EVENTS_LOGIN.RESET_PASSWORD_LOADED,
        true
      );
      this.nextDisplayView.nextDisplayView(VIEW_NAME.RESET_PASSWORD_SCREEN);
    }
  }

  // eslint-disable-next-line complexity
  routeLoginAssociatedPages() {
    switch (true) {
      case this.isForgotLoginScreen():
        this.forgotLoginFacade.resetForm();
        this.analytics.dispatchCustomEvent(
          ANALYTICS_EVENTS_LOGIN.FORGOT_LOGIN_LOADED,
          true
        );
        this.nextDisplayView.nextDisplayView(VIEW_NAME.FORGOT_LOGIN_SCREEN);
        break;
      case this.isResetPasswordScreen():
        this.resetPasswordFacade.getResetPasswordPageContent();
        this.isQueryParamsForResetPasswordHelper();
        this.analytics.dispatchCustomEvent(
          ANALYTICS_EVENTS_LOGIN.RESET_PASSWORD_LOADED,
          true
        );
        break;
      case this.isUnlockYourAccountScreen():
        this.nextDisplayView.nextDisplayView(VIEW_NAME.UNLOCK_ACCOUNT_SCREEN);
        break;
      case this.isLoginHelpScreen():
        this.nextDisplayView.nextDisplayView(VIEW_NAME.LOGIN_HELP_SCREEN);
        break;
      case this.isAddEmailScreen():
        this.nextDisplayView.nextDisplayView(
          VIEW_NAME.ADD_EMAIL_ADDRESS_SCREEN
        );
        break;
      case this.isAddSQAScreen():
        this.nextDisplayView.nextDisplayView(
          VIEW_NAME.ADD_SECURITY_QUESTION_ANS_SCREEN
        );
        break;
      case this.isAddAddressScreen():
        this.nextDisplayView.nextDisplayView(VIEW_NAME.ADD_ADDRESS_SCREEN);
        break;
      default:
        this.nextDisplayView.nextDisplayView(
          VIEW_NAME.LOGIN_CREDENTIALS_SCREEN
        );
        break;
    }
  }
}
